import { Injectable } from "@angular/core";
import { IDeviceNavigator } from "@ramudden/models/device";
import { ISearchResult, SearchParameters } from "@ramudden/models/search";
import { Observable } from "rxjs";
import { NavigatorWebApiService } from "./navigator-web-api";

@Injectable({
    providedIn: "root",
})
export class DeviceNavigatorWebApi extends NavigatorWebApiService<IDeviceNavigator> {
    override getRoute(): string {
        return "DeviceNavigators";
    }

    search$(code: string, skip: number = null, take: number = null): Observable<ISearchResult<IDeviceNavigator>> {
        const url = this.getUrl();

        const searchParameters = new SearchParameters();
        searchParameters.queryParams = {
            code: code,
            skip: skip,
            take: take,
        };

        const options = this.createOptions(null, searchParameters, null);
        return this.http.get<ISearchResult<IDeviceNavigator>>(url, options);
    }

    getByQrCode$(qrCode: string): Observable<IDeviceNavigator> {
        const url = this.getUrl();
        const urlAppend = `/qrCode/${qrCode}`;

        return this.http.get<IDeviceNavigator>(url + urlAppend);
    }
}
